export class Columns{
    private static firstElemtCloned: HTMLElement;

    static init() {
        document.addEventListener('DOMContentLoaded', Columns.onDocumentLoaded, false);
    }

    private static onDocumentLoaded() {
        
        var multipleContents = document.getElementsByClassName("_contentsectionWrapper");
        if(multipleContents.length > 0){
            for(var i = 0; i< multipleContents.length; i++){
                Columns.cloneFirstElement(multipleContents.item(i));
            }
        } else{
            Columns.cloneFirstElement(document);
        }
        var linksTemaplate = document.getElementById('p_twoColumnsLinks');
        if(linksTemaplate != null){
            Columns.renderMobileNavigation();
        }        
    }

    private static cloneFirstElement(section: any){
        var elementToClone = section.getElementsByClassName('av_one_third')[0];
        var cln = elementToClone.cloneNode(true);
        Columns.firstElemtCloned = section.getElementsByClassName('_firstElementCloned')[0];
        Columns.firstElemtCloned.appendChild(cln);
    }

    private static renderMobileNavigation(){
        var widgets = Columns.firstElemtCloned.getElementsByClassName('sshgWidget');
        var list = document.getElementsByClassName('_mobileLinks')[0];

        var firstlistItemHtml = document.createElement("li");
        var firstlistItemLinkHtml = document.createElement("a");

        firstlistItemLinkHtml.innerHTML = 'Die Abonnements';
        firstlistItemLinkHtml.href = '#Abonnements';

        document.getElementsByClassName('av_two_third')[0].id = 'Abonnements';

        firstlistItemHtml.appendChild(firstlistItemLinkHtml);
        list.appendChild(firstlistItemHtml);

        for(var i = 0; i<widgets.length; i++){
            var listItemHtml = document.createElement("li");
            var listItemLinkHtml = document.createElement("a");
            var title = widgets.item(i).getElementsByClassName('_title')[0].innerHTML;
 
            listItemLinkHtml.innerHTML = title;
            listItemLinkHtml.href = '#' + title;

            widgets.item(i).id = title;    
            
            listItemHtml.appendChild(listItemLinkHtml);
            list.appendChild(listItemHtml);
        }
    }
}